"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cookies() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3091" id="πολιτική-cookies" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32" style={{
    ["--background" as never]: "hsl(0 0% 100%)",
    ["--foreground" as never]: "hsl(229 75% 8%)"
  }}>
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div ref={contentRef} className={`transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-12">
            <h2 className="font-sans font-semibold text-foreground mb-8 tracking-tight" style={{
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            lineHeight: "1.1"
          }}>
              Πολιτική <span className="text-primary">Cookies</span>
            </h2>
            
            <div className="space-y-8 font-sans text-foreground/80 text-lg leading-relaxed">
              <div className="border-l-4 border-primary pl-6 py-2 bg-accent/5">
                <p className="font-medium text-foreground">
                  Η ιστοσελίδα μας χρησιμοποιεί αποκλειστικά και μόνο τα απαραίτητα cookies για την τεχνική λειτουργία της.
                </p>
              </div>

              <div className="space-y-6">
                <h3 className="text-xl font-bold text-foreground uppercase tracking-wider">
                  Τι είναι τα Cookies;
                </h3>
                <p>
                  Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στον υπολογιστή ή την κινητή συσκευή σας όταν επισκέπτεστε έναν ιστότοπο. Επιτρέπουν στον ιστότοπο να θυμάται τις ενέργειές σας και τις προτιμήσεις σας για ένα χρονικό διάστημα, ώστε να μην χρειάζεται να τις εισάγετε ξανά κάθε φορά που επισκέπτεστε τον ιστότοπο ή περιηγείστε από τη μια σελίδα στην άλλη.
                </p>
              </div>

              <div className="space-y-6">
                <h3 className="text-xl font-bold text-foreground uppercase tracking-wider">
                  Απαραίτητα Cookies
                </h3>
                <p>
                  Τα απαραίτητα cookies βοηθούν στο να γίνει χρηστική μία ιστοσελίδα, επιτρέποντας βασικές λειτουργίες όπως την πλοήγηση και την πρόσβαση σε ασφαλείς περιοχές της ιστοσελίδας. Η ιστοσελίδα δεν μπορεί να λειτουργήσει σωστά χωρίς αυτά τα cookies.
                </p>
                <p>
                  Δεδομένου ότι αυτά τα cookies είναι απολύτως απαραίτητα για την παροχή των υπηρεσιών μας μέσω της ιστοσελίδας, δεν απαιτείται η συγκατάθεσή σας για τη χρήση τους. Μπορείτε να ρυθμίσετε το πρόγραμμα περιήγησής σας ώστε να αποκλείει ή να σας ειδοποιεί για αυτά τα cookies, αλλά ορισμένα τμήματα της ιστοσελίδας ενδέχεται να μην λειτουργούν.
                </p>
              </div>

              <div className="pt-8 border-t border-border">
                <p className="text-sm text-muted-foreground italic">
                  Σημείωση: Η παρούσα ιστοσελίδα δεν χρησιμοποιεί cookies παρακολούθησης (tracking), διαφήμισης ή στατιστικών τρίτων μερών.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}